export default __webpack_public_path__ + "static/media/chamundeshwari temple.1896f7b8.jpg";